module.exports = __webpack_public_path__ + "static/SUOT_2020-4cbc88ac0a1e6caec892e102a539ae18.pdf";